import {IGameConfig} from './proptypes/gameConfig';
import {ISlide} from './slide';
import {PlayerLabel} from './playerLabel';
import {RequestParam} from './requestParams';
import {IAppliedRule} from './appliedRules';
import {ProtectionType} from './presentationProtection';
import {IRetryQuestion} from './elements/base/retryQuestion';

export interface IPresentation {
    _id: string;
    slides: ISlide[];
    found?: boolean;
    slideIndexList: string[];
    gameConfig: IGameConfig;
    scrollButtonsOn?: boolean;
    firstTimeUsing?: boolean | null;
    languageConfig?: {labels: PlayerLabel[]};
    toolbarColor?: string;
    emptySpaceColor?: string;
    presentationBackground?: string;
    presentationMobileBackground?: string;
    name: string;
    description?: string | null;
    created: string;
    lastModified: string;
    favorite?: boolean;
    newSlides?: ISlide[];
    workspaceSize?: {width: number; height: number};
    outerAreaColor?: string;
    backgroundColor?: string | null;
    presentationBackgroundName?: string;
    presentationMobileBackgroundName?: string;
    dataCollection?: boolean;
    userEmail?: string;
    userId?: string;
    firstSlidePreview?: string;
    protectionTypes?: ProtectionType[];
    requestParams?: RequestParam[];
    presentationThemeId?: string;
    appliedRules?: IAppliedRule[];
    isReadOnly?: boolean;
    isShared?: boolean;
    version?: string;
    retryQuestionSettings?: IRetryQuestion;
    /**
     * @deprecated Use `retryQuestionSettings` (IRetryQuestion) instead.
     */
    retryQuestion?: {
        isEnabled: boolean;
        attempts: number;
    };
}

export type IPresentationMeta = Omit<IPresentation, 'slides' | 'newSlides'>;

export enum PresentationsRequestStatus {
    ACCEPTED = 'ACCEPTED',
    DECLINED = 'DECLINED',
}

export enum SendOrShareType {
    SEND = 'SEND',
    SHARE = 'SHARE',
}
